"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmAssignationOffersResult = void 0;
var ConfirmAssignationOffersResult;
(function (ConfirmAssignationOffersResult) {
    ConfirmAssignationOffersResult["InvalidOrderStatus"] = "InvalidOrderStatus";
    ConfirmAssignationOffersResult["NotAllVehiclesCovered"] = "NotAllVehiclesCovered";
    ConfirmAssignationOffersResult["NoOffersToConfirm"] = "NoOffersToConfirm";
    ConfirmAssignationOffersResult["NotAllDriversAssigned"] = "NotAllDriversAssigned";
    ConfirmAssignationOffersResult["Success"] = "Success";
    ConfirmAssignationOffersResult["NotAllClaimsCovered"] = "NotAllClaimsCovered";
    ConfirmAssignationOffersResult["VehiclesCountMismatch"] = "VehiclesCountMismatch";
    ConfirmAssignationOffersResult["AlreadyConfirmed"] = "AlreadyConfirmed";
    ConfirmAssignationOffersResult["NoSuitableClaimFound"] = "NoSuitableClaimFound";
    ConfirmAssignationOffersResult["OrderNotFound"] = "OrderNotFound";
    ConfirmAssignationOffersResult["InvalidOffer"] = "InvalidOffer";
    ConfirmAssignationOffersResult["ClaimNotFound"] = "ClaimNotFound";
    ConfirmAssignationOffersResult["ComboOfferStillPending"] = "ComboOfferStillPending";
})(ConfirmAssignationOffersResult || (exports.ConfirmAssignationOffersResult = ConfirmAssignationOffersResult = {}));
//# sourceMappingURL=confirm-assignation-offers-result.enum.js.map